import * as requestType from '../ressources/glossaires/glossaire_requetes';
import { setUrlPathFromDomain } from '../services/utils/utils';
import {
  FunctionInformation,
  PlanningForm,
  ProjectFailureRateResponse,
  SensorFailureRateResponse,
  SensorTypeReponse,
} from '../types/types';
import {
  _post,
  _postAllHeaders,
  _postFormData,
  _get,
  _delete,
  _put,
  _getArgosV25,
  _postArgosV25,
  _putArgosV25,
  _deleteArgosV25,
  _postArgosV25TasksDebug,
} from './axios';
import axios from 'axios';

// Nouvelles fonctions avec gestion d'erreur et timeout pour éviter les boucles infinies
const _postSafe = async (
  body: any,

  timeoutMs: number = 10000000
): Promise<any> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await axios.post('', body, {
      headers: {
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error: any) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      console.error('Request timeout:', error);
      throw new Error('Request timeout');
    }
    console.error('Request error:', error);
    throw error;
  }
};

const envBaseUrl =
  (process.env.REACT_APP_API_BASE_URL_LOCAL &&
    process.env.REACT_APP_API_BASE_URL_LOCAL.trim() !== '' &&
    process.env.REACT_APP_API_BASE_URL_LOCAL) ||
  process.env.REACT_APP_API_BASE_URL;

let cheminURLAPI =
  envBaseUrl && envBaseUrl.trim() !== ''
    ? envBaseUrl
    : setUrlPathFromDomain(
        'http://localhost:4000',
        'https://argos-v19.itmsol.fr/index.php',
        'https://argos-v25.itmsol.fr/index.php',
        'https://argos-dev.itmsol.fr/index.php'
      );
axios.defaults.baseURL = cheminURLAPI;

//AUTHENTIFICATION (auth.js dans les actions redux)
export const authentication = (payload: {
  login_name: string;
  login_password: string;
}) => {
  return _postAllHeaders({
    request_type: requestType.connexion,
    login_name: payload.login_name,
    login_password: payload.login_password,
  });
};

export const logout = () => {
  return _post({
    request_type: requestType.deconnexion,
  });
};

export const askForPasswordReset = (payload: { email: string }) => {
  return _postAllHeaders({
    email: payload.email,
    request_type: requestType.demande_de_reinitialisation_du_mot_de_passe,
  });
};

export const resetPassword = () => {
  return _postAllHeaders({
    request_type: requestType.reinitialisation_du_mot_de_passe,
  });
};

export const validateCodeVerification = (payload: {
  codeVerification: string;
}) => {
  return _postAllHeaders({
    request_type: requestType.validation_du_code_de_verification,
    verification_code: payload.codeVerification,
  });
};

export const checkConnexion = () => {
  return _post({ request_type: requestType.information_de_connexion });
};

export const requestPasswordChange = (payload: any) => {
  return _postAllHeaders({
    request_type: requestType.changer_son_mot_de_passe,
    ...payload,
  });
};

//ALARME (alarme.js dans les actions redux)
export const getAllAlarmsWithIdProject = (payload: {
  list_project_id: any;
}) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_alarmes,
    list_project_id: payload.list_project_id,
  });
};

export const getConfirmationAlarm = (payload: any) => {
  return _post({
    request_type: requestType.confirmer_une_alarme,
    ...payload,
  });
};

export const getListMailGroupsWithIdProject = (payload: {
  list_project_id: any;
}) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_groupes_d_email,
    list_project_id: payload.list_project_id,
  });
};

export const createGroupMail = (payload: any) => {
  return _post({
    request_type: requestType.creer_un_groupe_d_email,
    ...payload,
  });
};

export const updateGroupMail = (payload: any) => {
  return _post({
    request_type: requestType.modifier_un_groupe_d_email,
    ...payload,
  });
};

export const deleteGroupMail = (payload: { group_email_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_groupe_d_email,
    group_email_id: payload.group_email_id,
  });
};

export const createAlarmTemplate = (payload: any) => {
  return _post({
    request_type: requestType.creer_un_gabarit,
    ...payload,
  });
};

export const updateAlarmTemplate = (payload: any) => {
  return _post({
    request_type: requestType.modifier_un_gabarit,
    ...payload,
  });
};

export const deleteAlarmTemplate = (payload: { template_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_gabarit,
    template_id: payload.template_id,
  });
};

export const getAllAlarmTemplatesWithIdProject = (payload: {
  list_project_id: any;
}) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_gabarits,
    list_project_id: payload.list_project_id,
  });
};

export const createAlarmXY = (payload: any) => {
  return _post({
    request_type: requestType.configurer_des_alarmes_xy,
    ...payload,
  });
};

export const updateAlarmXY = (payload: any) => {
  return _post({
    request_type: requestType.modifier_des_alarmes_xy,
    ...payload,
  });
};

export const deleteAlarmXY = (payload: { alarm_xy_id: string }) => {
  return _post({
    request_type: requestType.supprimer_une_configuration_d_alarme_xy,
    alarm_xy_id: payload.alarm_xy_id,
  });
};

export const getAllAlarmsXYWithIdProject = (payload: {
  list_project_id: any;
}) => {
  return _post({
    request_type:
      requestType.recuperer_la_liste_des_configurations_des_alarmes_xy,
    list_project_id: payload.list_project_id,
  });
};

//CAPTEUR (capteur.js dans les actions redux)

export const createCapteur = (payload: any) => {
  return _post({
    request_type: requestType.creation_d_un_capteur,
    ...payload,
  });
};

export const updateCapteur = (payload: any) => {
  return _post({
    request_type: requestType.modification_d_un_capteur,
    ...payload,
  });
};

export const deleteCapteur = (payload: { sensor_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_capteur,
    sensor_id: payload.sensor_id,
  });
};

export const getSensorTypesList = (): Promise<SensorTypeReponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_sensor_type,
  });
};

export const createSensorType = (payload: {
  sensor_type_name: string;
  sensor_type_display: string;
}) => {
  return _post({
    request_type: requestType.creation_d_un_sensor_type,
    sensor_type_name: payload.sensor_type_name,
    sensor_type_display: payload.sensor_type_display,
  });
};

export const updateSensorType = (payload: any) => {
  return _post({
    request_type: requestType.modification_d_un_sensor_type,
    ...payload,
  });
};

export const deleteSensorType = (payload: { sensor_type_id: string }) => {
  return _post({
    request_type: requestType.suppression_d_un_sensor_type,
    sensor_type_id: payload.sensor_type_id,
  });
};

export const getAllCapteurByProjectId = (payload: { projects_id: any }) => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_capteurs,
    projects_id: payload.projects_id,
  });
};

export const getAllImportFilters = () => {
  return _post({
    request_type:
      requestType.recuperation_de_la_liste_des_filtres_d_importation,
  });
};

export const getAllEmailGroups = () => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_groupes_d_emails,
  });
};

export const createOrReplaceImageForSensorType = (payload: any) => {
  return _post({
    request_type: requestType.ajouter_une_image_de_type_de_capteur,
    ...payload,
  });
};

export const importSensorBundle = (payload: any) => {
  return _post({
    request_type: requestType.importation_des_capteurs_en_lot,
    ...payload,
  });
};

// GRAPHES (graphe.js dans les actions)
export const getAllGraphs = (payload: { projects_id: any }) => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_graphes,
    projects_id: payload.projects_id,
  });
};

export const deleteGraph = (payload: { graph_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_graphe,
    graph_id: payload.graph_id,
  });
};

export const getGraph = (payload: { graph_id: string }) => {
  return _postSafe({
    request_type: requestType.recuperer_un_graphe,
    graph_id: payload.graph_id,
  });
};

export const getGraphData = (payload: {
  graph_id: string;
  time_period?: any;
  measures_num?: any;
  select_time?: any;
  time_interval?: any[];
}) => {
  const { graph_id, time_period, measures_num, select_time, time_interval } =
    payload;
  return _postSafe({
    request_type: requestType.recuperation_des_donnees_d_un_graphe,
    graph_id,
    time_period: time_period === undefined ? null : time_period,
    measures_num: measures_num === undefined ? null : measures_num,
    select_time: select_time === undefined ? [] : select_time,
    time_interval: time_interval === undefined ? [null, null] : time_interval,
  });
};

export const getAutoGraphDataXT = (payload: {
  sensor_id: string;
  position_in_sensor: number;
  time_period?: any;
  measures_num?: any;
  select_time?: any;
  time_interval?: any[];
}) => {
  const {
    sensor_id,
    position_in_sensor,
    time_period,
    measures_num,
    select_time,
    time_interval,
  } = payload;
  return _postSafe({
    request_type:
      requestType.recuperation_des_donnees_d_un_graphe_automatique_xt,
    sensor_id,
    position_in_sensor,
    time_period: time_period === undefined ? null : time_period,
    measures_num: measures_num === undefined ? null : measures_num,
    select_time: select_time === undefined ? [] : select_time,
    time_interval: time_interval === undefined ? [null, null] : time_interval,
  });
};

export const createGraph = (payload: { config: any }) => {
  return _post({
    request_type: requestType.creer_un_graphe,
    config: payload.config,
  });
};

export const updateGraph = (payload: { config: any }) => {
  return _post({
    request_type: requestType.modifier_un_graphe,
    config: payload.config,
  });
};

export const getDateFormat = () => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_formats_de_dates,
  });
};

//PRIVILEGE (privilege.js dans les actions redux)
export const getPrivileges = () => {
  return _post({
    request_type:
      requestType.liste_des_privileges_associes_a_une_categorie_d_utilisateur,
  });
};

//PROJETS (projet.js dans les actions redux)
export const getProjects = () => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_projets,
  });
};

export const createProject = (payload: any) => {
  return _post({
    request_type: requestType.creation_d_un_projet,
    ...payload,
  });
};
export const updateProject = (payload: any) => {
  return _post({
    request_type: requestType.modification_d_un_projet,
    ...payload,
  });
};
export const deleteProject = (payload: { project_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_projet,
    project_id: payload.project_id,
  });
};

export const addImageToProject = (payload: {
  project_id: string;
  image: string;
}) => {
  return _post({
    request_type: requestType.ajouter_une_image_de_projet,
    project_id: payload.project_id,
    image: payload.image,
  });
};

export const removeImageFromProject = (payload: { project_id: string }) => {
  return _post({
    request_type: requestType.ajouter_une_image_de_projet,
    project_id: payload.project_id,
  });
};

export const addProjectToFavorite = (payload: { project_id: string }) => {
  return _post({
    request_type: requestType.rajouter_un_projet_en_favori,
    project_id: payload.project_id,
  });
};

export const removeProjectfromFavorite = (payload: { project_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_projet_des_favoris,
    project_id: payload.project_id,
  });
};

export const getFavortiesProject = () => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_projets_des_favoris,
  });
};

//RAPPORTS (rapport.js dans les actions redux)

export const getPublishedReports = (payload: { list_project_id: any }) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_rapports_publies,
    list_project_id: payload.list_project_id,
  });
};

export const getPublishedTemplateReports = (payload: {
  list_project_id: any;
}) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_rapports_gabarits,
    list_project_id: payload.list_project_id,
  });
};

export const createTemplateReport = (payload: any) => {
  return _post({
    request_type: requestType.creer_un_rapport_gabarit,
    ...payload,
  });
};

export const updateTemplateReport = (payload: any) => {
  return _post({
    request_type: requestType.modifier_un_rapport_gabarit,
    ...payload,
  });
};

export const deleteTemplateReport = (payload: {
  template_report_id: string;
}) => {
  return _post({
    request_type: requestType.supprimer_un_rapport_gabarit,
    template_report_id: payload.template_report_id,
  });
};

export const createReport = (payload: {
  template_report_id: string;
  start_report: any;
  end_report: any;
}) => {
  return _post({
    request_type: requestType.generer_un_rapport,
    template_report_id: payload.template_report_id,
    start_report: payload.start_report,
    end_report: payload.end_report,
  });
};

export const getAllReports = (payload: {
  list_project_id: any;
  start_list_generate_report: any;
  end_list_generate_report: any;
}) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_rapports_generes,
    list_project_id: payload.list_project_id,
    start_list_generate_report: payload.start_list_generate_report,
    end_list_generate_report: payload.end_list_generate_report,
  });
};

export const publishReports = (payload: { generate_report_id: any }) => {
  return _post({
    request_type: requestType.publier_un_rapport_genere,
    generate_report_id: payload.generate_report_id,
  });
};

export const deleteReports = (payload: { generate_report_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_rapport_genere,
    generate_report_id: payload.generate_report_id,
  });
};

export const getTemplateReportConfig = async (payload: {
  path_config: string;
}) => {
  const baseUrl = setUrlPathFromDomain(
    'http://localhost:4000',
    'https://argos-v19.itmsol.fr',
    'https://argos-v25.itmsol.fr',
    'https://argos-dev.itmsol.fr'
  );

  let origin = 'https://argos-v19.itmsol.fr';
  try {
    origin = new URL(baseUrl).origin;
  } catch (error) {
    origin = 'https://argos-v19.itmsol.fr';
  }

  const rawPath =
    typeof payload?.path_config === 'string' ? payload.path_config.trim() : '';

  if (!rawPath) {
    throw new Error('path_config is empty');
  }

  let url = '';
  try {
    const absoluteUrl = new URL(rawPath);
    if (absoluteUrl.hostname === 'localhost') {
      url =
        origin +
        absoluteUrl.pathname +
        (absoluteUrl.search || '') +
        (absoluteUrl.hash || '');
    } else {
      url = rawPath;
    }
  } catch (error) {
    if (rawPath.startsWith('/')) {
      url = origin + rawPath;
    } else {
      url = origin + '/' + rawPath;
    }
  }

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      varget0: Math.random(),
    },
  });
};

// UTILISATEURS (utilisateur.js dans les actions redux)

export const createUser = (payload: any) => {
  return _post({
    request_type: requestType.creation_d_un_utilisateur,
    ...payload,
  });
};

export const updateUser = (payload: any) => {
  return _post({
    request_type: requestType.modification_d_un_utilisateur,
    ...payload,
  });
};

export const deleteUser = (payload: { user_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_utilisateur,
    user_id: payload.user_id,
  });
};

export const getAllUsers = () => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_utilisateurs,
  });
};

export const getUser = (payload: { user_id: string }) => {
  return _post({
    request_type: requestType.recuperation_d_un_utilisateur,
    user_id: payload.user_id,
  });
};

export const generateReportClientSide = (payload: any) => {
  return _post({
    request_type: requestType.generer_rapport_cote_client,
    ...payload,
  });
};

//VUES (vue.js dans les actions redux)

export const getViewByProjectIds = (payload: { list_project_id: any }) => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_vues,
    list_project_id: payload.list_project_id,
  });
};

export const getView = (payload: { view_id: number }) => {
  return _post({
    request_type: requestType.recuperer_une_vue,
    view_id: payload.view_id,
  });
};

export const createView = (payload: any) => {
  return _post({
    request_type: requestType.creer_une_vue,
    ...payload,
  });
};

export const addViewLayer = (payload: any) => {
  return _post({
    request_type: requestType.ajouter_une_couche_de_vue,
    ...payload,
  });
};

export const getViewLayers = (payload: { view_id: string }) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_couches_de_vue,
    view_id: payload.view_id,
  });
};

export const getFavoriteDashboards = () => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_tableaux_de_bord_favoris,
  });
};

export const updateUserFavoriteDashboards = (payload: {
  user_id: string;
  favorite_views_list: any;
}) => {
  return _post({
    request_type:
      requestType.modifier_la_liste_des_tableaux_de_bord_favoris_utilisateur,
    user_id: payload.user_id,
    favorite_views_list: payload.favorite_views_list,
  });
};

export const getUserDashboards = (payload: { user_id: string }) => {
  return _post({
    request_type:
      requestType.recuperer_la_liste_des_tableaux_de_bord_utilisateur,
    user_id: payload.user_id,
  });
};

export const updateLayersOrder = (payload: {
  view_id: string;
  layers_position_order_list: any;
}) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_tableaux_de_bord_favoris,
    view_id: payload.view_id,
    layers_position_order_list: payload.layers_position_order_list,
  });
};

export const deleteLayerFromView = (payload: { layer_id: string }) => {
  return _post({
    request_type: requestType.supprimer_une_couche_de_vue,
    layer_id: payload.layer_id,
  });
};

export const updateView = (payload: any) => {
  return _post({
    request_type: requestType.modifier_une_vue,
    ...payload,
  });
};

export const deleteView = (payload: { view_id: string }) => {
  return _post({
    request_type: requestType.supprimer_une_vue,
    view_id: payload.view_id,
  });
};

export const getAllObjectsFromView = (payload: { view_id: string }) => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_objets_associe_a_la_vue,
    view_id: payload.view_id,
  });
};

export const addObjectToView = (payload: { view_id: number; viewobj: any }) => {
  return _post({
    request_type: requestType.ajouter_un_objet_associe_a_la_vue,
    view_id: payload.view_id,
    viewobj: payload.viewobj,
  });
};

export const updateObjectFromView = (payload: {
  viewobj_id: number;
  view_id: number;
  viewobj: any;
}) => {
  return _post({
    request_type: requestType.modifier_un_objet_associe_a_la_vue,
    ...payload,
  });
};

export const removeObjectFromView = (payload: { viewobj_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_objet_associe_a_la_vue,
    viewobj_id: payload.viewobj_id,
  });
};

export const getAllObjectsToDisplayFromView = (payload: {
  view_id: string;
}) => {
  return _post({
    request_type:
      requestType.recuperer_la_liste_des_objets_a_afficher_associes_a_une_vue,
    view_id: payload.view_id,
  });
};

export const getAdditonalDataOfObject = (payload: {
  view_id: string;
  viewobj_id: string;
}) => {
  return _post({
    request_type:
      requestType.recuperer_les_informations_complementaires_d_un_objet,
    view_id: payload.view_id,
    viewobj_id: payload.viewobj_id,
  });
};

//MAINTENANCE
export const getFailureRatePerProject = (
  startInterval: number,
  endInterval: number,
  typesIdList: number[],
  criticityIdList: string[],
  filteredProjects: number[]
): Promise<ProjectFailureRateResponse> => {
  return _post({
    request_type: requestType.recuperer_objet_projets_taux_de_pannes,
    start_interval: startInterval,
    end_interval: endInterval,
    types_id_list: typesIdList,
    criticity_id_list: criticityIdList,
    projects_id: filteredProjects,
  });
};

export const getDailyFailureRate = (payload: {
  startInterval: number;
  endInterval: number;
  typesIdList: string[];
  criticityIdList: string[];
  filteredProjects: number[];
}): Promise<ProjectFailureRateResponse> => {
  return _post({
    request_type: requestType.graphe_taux_de_pannes,
    ...payload,
  });
};

export const getSensorFailureRatePerProject = (
  startInterval: number,
  endInterval: number,
  typesIdList: number[],
  criticityIdList: string[],
  filteredProjects: number[]
): Promise<SensorFailureRateResponse> => {
  return _post({
    request_type: requestType.liste_des_capteurs_defaillants_par_projet,
    start_interval: startInterval,
    end_interval: endInterval,
    types_id_list: typesIdList,
    criticity_id_list: criticityIdList,
    projects_id: filteredProjects,
  });
};

// PLANNING
//Récupérer toutes les vues + les vue planning

export const getFunctions = () => {
  const route = 'api/functions';
  return _getArgosV25({ route: route });
};

export const getFunctionById = (payload: { functionId: number }) => {
  const route = `api/function/${payload.functionId}`;
  return _getArgosV25({ route: route });
};

export const getTasksByIdProject = (payload: { projectIds: number[] }) => {
  const route = `api/task/projects?project_ids=${payload.projectIds.join(',')}`;
  return _getArgosV25({ route: route });
};

export const getViews = () => {
  const route = 'api/view';
  return _getArgosV25({ route: route });
};

//Récupérer les informations de la fonction pour alimenter le formulaire (définition des arguments)
export const getFunctionInformation = (
  payload: any
): Promise<FunctionInformation> => {
  const route = `api/view/${payload.viewType}`;
  return _getArgosV25({ route: route });
};

//Créer la vue + le planning (7 tâches avec mode par défaut, une par jour à 00h)

export const createViewPlanning = (payload: PlanningForm) => {
  const route = 'api/view/schedule';
  return _postArgosV25({ route: route, payload: payload });
};

export const getTasksFromViewPlanning = (payload: { viewId: number }) => {
  const route = `api/task/${payload.viewId}`;
  return _getArgosV25({ route: route });
};

//Mettre à jour les infos de la vue, les infos planning
export const updateViewPlanning = (payload: PlanningForm) => {
  const route = `api/view/schedule`;
  return _postArgosV25({ route: route, payload: payload });
};
// //Supprimer la vue, le planning, les tâches
// export const deleteTask = (payload: { taskId: number }) => {
//   const route = `api/view/schedule/${payload.taskId}`;
//   return _deleteArgosV25({ route: route });
// };
//Mettre à jour les taches, le mode on/off, le mode auto, le mode manuel avec la commande de l'utilisateur
export const startModeAuto = (payload: { viewType: string }) => {
  const route = `api/view/schedule/start/${payload.viewType}`;
  return _putArgosV25({ route: route, payload: payload });
};

export const stopModeAuto = (payload: { viewType: string }) => {
  const route = `api/view/schedule/stop/${payload.viewType}`;
  return _putArgosV25({ route: route, payload: payload });
};

export const switchManualMode = (payload: { viewType: string }) => {
  const route = `api/view/schedule/manual/${payload.viewType}`;
  return _postArgosV25({ route: route, payload: payload });
};

export const getSensorsInUseInPlannings = (payload: { projectId: number }) => {
  const route = `api/sensors/${payload.projectId}`;
  return _getArgosV25({ route: route });
};

// FAVORIS (backend legacy api.php - request_type 10619 reutilise pour vues/dashboards)
export const updateFavoriteViews = (payload: {
  user_id: number;
  favorite_views_list: number[];
}) => {
  return _post({
    request_type:
      requestType.modifier_la_liste_des_tableaux_de_bord_favoris_utilisateur,
    user_id: payload.user_id,
    favorite_views_list: payload.favorite_views_list,
  });
};

export const updateFavoriteDashboards = (payload: {
  user_id: number;
  favorite_views_list: number[];
}) => {
  return _post({
    request_type:
      requestType.modifier_la_liste_des_tableaux_de_bord_favoris_utilisateur,
    user_id: payload.user_id,
    favorite_views_list: payload.favorite_views_list,
  });
};

// FAVORIS (backend Symfony / API v25)

export const getFavoriteViewsV25 = (payload: { userId: number }) => {
  const route = `api/favorites/${payload.userId}/views`;
  return _getArgosV25({ route: route });
};

export const updateFavoriteViewsV25 = (payload: {
  userId: number;
  viewId: number;
}) => {
  const route = `api/favorites/${payload.userId}/views/${payload.viewId}`;
  return _postArgosV25({ route: route });
};

export const removeFavoriteViewsV25 = (payload: {
  userId: number;
  viewId: number;
}) => {
  const route = `api/favorites/${payload.userId}/views/${payload.viewId}`;
  return _deleteArgosV25({ route: route });
};

export const getFavoriteDashboardsV25 = (payload: { userId: number }) => {
  const route = `api/favorites/${payload.userId}/views`;
  return _getArgosV25({ route: route });
};

export const updateFavoriteDashboardsV25 = (payload: {
  userId: number;
  dashboardId: number;
}) => {
  const route = `api/favorites/${payload.userId}/views/${payload.dashboardId}`;
  return _postArgosV25({ route: route });
};

export const removeFavoriteDashboardsV25 = (payload: {
  userId: number;
  dashboardId: number;
}) => {
  const route = `api/favorites/${payload.userId}/views/${payload.dashboardId}`;
  return _deleteArgosV25({ route: route });
};

export const getFavoriteGraphsV25 = (payload: { userId: number }) => {
  const route = `api/favorites/${payload.userId}/graphs`;
  return _getArgosV25({ route: route });
};

export const updateFavoriteGraphsV25 = (payload: {
  userId: number;
  graphId: number;
}) => {
  const route = `api/favorites/${payload.userId}/graphs/${payload.graphId}`;
  return _postArgosV25({ route: route });
};

export const removeFavoriteGraphsV25 = (payload: {
  userId: number;
  graphId: number;
}) => {
  const route = `api/favorites/${payload.userId}/graphs/${payload.graphId}`;
  return _deleteArgosV25({ route: route });
};

export const getHomeSummaryV25 = (payload: { userId: number }) => {
  return _getArgosV25({ route: `api/home/summary/${payload.userId}` });
};

export const authenticateV25 = (payload: { userId: number }) => {
  const route = 'api/check-auth';
  return _postArgosV25({ route: route, payload: payload });
};

// TASKS

export const createFunction = (payload: { functionData: any }) => {
  const route = `api/functions`;
  return _postArgosV25({ route: route, payload: payload.functionData });
};

export const updateFunction = (payload: {
  functionId: number;
  functionData: any;
}) => {
  const route = `api/functions/${payload.functionId}`;
  return _putArgosV25({ route: route, payload: payload.functionData });
};

export const deleteFunction = (payload: { functionId: number }) => {
  const route = `api/functions/${payload.functionId}`;
  return _deleteArgosV25({ route: route });
};

export const getSensorsStatusInPlannings = (payload: {
  sensor_ids: number[];
}) => {
  const route = `api/sensors-status`;
  return _postArgosV25({
    route: route,
    payload: { sensor_ids: payload.sensor_ids },
  });
};

export const createTask = (payload: { taskData: any }) => {
  const route = `api/task`;
  return _postArgosV25({ route: route, payload: payload.taskData });
};

export const updateTask = (payload: { taskId: number; taskData: any }) => {
  const route = `api/task/${payload.taskId}`;
  return _putArgosV25({ route: route, payload: payload.taskData });
};

//Supprimer la vue, le planning, les tâches
export const deleteTask = (payload: { taskId: number }) => {
  const route = `api/task/${payload.taskId}`;
  return _deleteArgosV25({ route: route });
};

// Exécuter une tâche manuellement
export const executeTask = (payload: { taskId: number }) => {
  // const route = `execute-task/${payload.taskId}`
  const route = `api/task/schedule/${payload.taskId}`;
  const res = _putArgosV25({ route: route });
  return res;
};

export const getVEnvs = () => {
  const route = `api/venvs`;
  return _getArgosV25({ route: route });
};

export const setVEnvToFunction = (payload: { venvId: number }) => {
  const route = `/api/functions/${payload.venvId}/venv`;
  return _putArgosV25({ route: route });
};

export const createVEnv = (payload: { venvData: any }) => {
  const route = `api/venvs`;
  return _postArgosV25({ route: route, payload: payload.venvData });
};

export const deleteVEnv = (payload: { venvId: number }) => {
  const route = `api/venvs/${payload.venvId}`;
  return _deleteArgosV25({ route: route });
};

// JALON/LABEL ET PHASE

export const getLabels = (payload: { sensorId: number; graphId: number }) => {
  const route = `api/labels/${payload.sensorId}?graphId=${payload.graphId}`;
  return _getArgosV25({ route: route });
};

export const createLabel = (payload: {
  id_sensor: number;
  time_unix: number;
  position_in_sensor: number;
  label_text: string;
  source: string;
}) => {
  const route = `api/labels`;
  return _postArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const updateLabel = (payload: {
  labelId: number;
  time_unix: number;
  position_in_sensor: number;
  label_text: string;
  source: string;
}) => {
  const route = `api/labels/${payload.labelId}`;
  return _putArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const deleteLabel = (payload: { labelId: number }) => {
  const route = `api/labels/${payload.labelId}`;
  return _deleteArgosV25({ route: route });
};

export const getPhases = (payload: { sensorId: number }) => {
  const route = `api/phases/${payload.sensorId}`;
  return _getArgosV25({ route: route });
};

export const createPhase = (payload: {
  graph_id: number;
  id_sensor: number;
  pk_test_ref_start: number;
  pk_test_ref_end: number;
  time_start: number;
  time_end: number;
  phase_text: string;
  color_hex: string;
}) => {
  const route = `api/phases`;
  return _postArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const updatePhase = (payload: {
  phaseId: number;
  graph_id: number;
  id_sensor: number;
  pk_test_ref_start: number;
  pk_test_ref_end: number;
  time_start: number;
  time_end: number;
  phase_text: string;
  color_hex: string;
}) => {
  const route = `api/phases/${payload.phaseId}`;
  return _putArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const deletePhase = (payload: { phaseId: number }) => {
  const route = `api/phases/${payload.phaseId}`;
  return _deleteArgosV25({ route: route });
};

// DATA MANAGER

export type SensorData = {
  pk_test: number;
  time_unix: number;
  position_in_sensor: number;
  value: number;
  calc_value: number;
};

export const getDataFromSensor = (payload: {
  sensorId: number;
  position_in_sensor: number;
  time_period?: [number, number] | null;
  n_values?: number | null;
}): Promise<SensorData[]> => {
  const route = `api/sensors/${payload.sensorId}/${payload.position_in_sensor}?time_period=${payload.time_period ? payload.time_period.join(',') : ''}&n_values=${payload.n_values ?? ''}`;
  return _getArgosV25({ route: route });
};

export const getDataFromSensors = (payload: {
  sensors_positions: Record<number, number[]>;
  time_period?: [number, number] | null;
  n_values?: number | null;
}): Promise<any> => {
  const route = 'api/sensors/data/bulk';
  return _postArgosV25({ route: route, payload });
};

export const updateDataFromSensor = (payload: {
  sensorId: number;
  pk_test: number;
  time_unix: number;
  position_in_sensor: number;
  value: number;
  calc_value: number;
}) => {
  const route = `api/sensors/${payload.sensorId}/data/${payload.pk_test}`;
  return _putArgosV25({ route: route, payload: payload });
};

export const updateDataFromSensors = (payload: {
  user_id?: number;
  sensors_data: Record<
    number,
    Array<{
      pk_test: number;
      time_unix?: number;
      old_time_unix?: number;
      position_in_sensor?: number;
      value?: number;
      old_value?: number;
      calc_value?: number;
      old_calc_value?: number;
    }>
  >;
}) => {
  const route = 'api/sensors/data/bulk-update';
  return _putArgosV25({ route: route, payload });
};

export const deleteDataFromSensor = (payload: {
  sensorId: number;
  pk_test: number;
}) => {
  const route = `api/sensors/${payload.sensorId}/data/${payload.pk_test}`;
  return _deleteArgosV25({ route: route });
};

export const deleteDataFromSensors = (payload: {
  user_id?: number;
  sensors_pk_tests: Record<number, number[]>;
}) => {
  const route = 'api/sensors/data/bulk-delete';
  return _deleteArgosV25({ route: route, payload });
};

export const importCSVApiCall = (payload: {
  user_id?: number;
  sensors_data?: {
    pk_test?: string | null;
    time_unix?: string;
    value?: string;
    calc_value: string;
    position_in_sensor?: string;
    sensor_id?: string;
  }[];
}) => {
  const route = 'api/sensors/data/csv-import';
  return _postArgosV25({ route, payload });
};

export const restoreDataFromSensor = (payload: {
  user_id?: number;
  sensors_data: Record<
    number,
    {
      pk_test?: number;
      time_unix?: number;
      value?: number;
      calc_value: number;
      position_in_sensor?: number;
    }
  >;
}) => {
  const route = 'api/sensors/data/bulk-restore';
  return _postArgosV25({ route, payload });
};

export type SensorDataHistoryEntry = {
  id: number;
  user_id: number;
  user_name?: string;
  sensor_id: number;
  pk_test: number;
  position_in_sensor: number;
  old_time_unix: number | null;
  new_time_unix: number | null;
  old_value: number | null;
  new_value: number | null;
  old_calc_value: number | null;
  new_calc_value: number | null;
  update_type: 'Edit' | 'Delete' | 'Restore' | 'Added';
  modification_date: number | string;
};

export const getSensorDataHistory = (payload: {
  sensor_ids: number[];
  user_id: number;
}): Promise<any> => {
  const route = 'api/sensors/data/history';
  return _postArgosV25({ route: route, payload });
};
